import { render, staticRenderFns } from "./step_description_archive.vue?vue&type=template&id=834fd864&scoped=true"
import script from "./step_description_archive.vue?vue&type=script&lang=js"
export * from "./step_description_archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834fd864",
  null
  
)

export default component.exports